import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("popover");
    const popover = new bootstrap.Popover(this.element);
  }

}
